﻿// <auto-generated/>
// this class has been generated with PowerShell
// see ./solution/Sbb.Meetings.Core/pre-build.ps1
/* eslint-disable */

import { TranslationLabels } from "./TranslationLabels";
export const frenchLabels: TranslationLabels = {
  Actions: "Actions",
  Actions_Activate: "Activer",
  Actions_Add: "Ajouter",
  Actions_AddBoard: "Ajouter une organe",
  Actions_AddComment: "ajouter un commentaire",
  Actions_AddRun: "Ajouter une activité",
  Actions_AddTopic: "Ajouter un thème",
  Actions_Back: "Retour à",
  Actions_Cancel: "Annuler",
  Actions_ChangeRunStatus: "Changer de statut",
  Actions_CreateEmail_Success: "L'email a été créé avec succès.",
  Actions_Deactivate: "Déactiver",
  Actions_Delete: "Supprimer",
  Actions_DeleteBoard: "Supprimer l'organe",
  Actions_DeleteRun: "Supprimer l'activité",
  Actions_DeleteRunTopic: "Supprimer le thème",
  Actions_DownloadBoardsExcel: "Télécharger la liste de l'organe",
  Actions_DownloadConfiguration: "Télécharger la configuration",
  Actions_DownloadFile: "Télécharger le fichier '{name}' …",
  Actions_DownloadRunDocuments: "obtenir le zip de tous les documents",
  Actions_DownloadRunDocuments_Empty: "Il n'y a pas de fichiers à télécharger.",
  Actions_Edit: "Modifier",
  Actions_EditBoard: "Modifier l'organe",
  Actions_EditComment: "editer un commentaire",
  Actions_EditRun: "Editer une activité",
  Actions_EditTopic: "Editer un thème",
  Actions_GoToBoard: "Ouvrir les configurations de l'organe",
  Actions_GoToRuns: "Ouvrir les activités de l'organe",
  Actions_GoToVote: "Vers le vote",
  Actions_Help: "Aide",
  Actions_HideChildren: "Masquer les subordonnés",
  Actions_HideDiff: "Masquer les différences",
  Actions_None: "Aucune",
  Actions_Open: "Ouvrir",
  Actions_Opendocument: "ouvrir un document",
  Actions_OpenPhonebook: "Ouvrir l'annuaire téléphonique",
  Actions_OpenUserProfile: "Ouvrir le profil utilisateur",
  Actions_PublishRun: "Envoi d'invitations et publication de l'activité",
  Actions_Refresh: "Actualiser",
  Actions_Reset: "Réinitialiser",
  Actions_Save: "Sauvegarder",
  Actions_SendEmail_Success: "Email envoyé avec succès.",
  Actions_SendReminders: "Envoyer un rappel",
  Actions_SendSiveResults_Failure: "Le resultat ne peut pas être einvoyé vers SiVe!",
  Actions_SendSiveResults_Success: "Le résultat a été envoyé vers SiVe avec succès.",
  Actions_SendToSive: "Envoyer les résultats à SiVe",
  Actions_ShowChildren: "Afficher les subordonnés",
  Actions_ShowDiff: "Afficher les différences",
  Actions_Synchronize: "Synchroniser",
  Actions_ToggleComments: "Afficher les commentaires",
  Actions_ToggleResults: "Afficher les résultats",
  Actions_ToggleTopics: "Développer/Réduire tous les thèmes",
  Actions_UploadDocument: "Ajouter un document",
  Actions_View: "Détails",
  Actions_View_History: "Historique des versions",
  Actions_ViewHistory: "Voir l'histoire",
  AddUser_Label: "Ajouter utilisateur*",
  AdminChart_Answered: "Membres qui ont répondu complètement",
  AdminChart_NoResults: "Aucun progrès",
  AdminChart_NotAnswered: "Membres qui n'ont pas répondu du tout ou pas complètement",
  Administration_Restriction: "Tu dois être administrateur pour voir cette page.",
  AdministratorsHaveAccessToo: "Les administrateurs actuels de l'application y ont également accès.",
  AdminUsersFilter_Placeholder: "Recherche des utilisateurs …",
  AliasOptional: "Alias (facultatif)",
  Answer_Abstention: "Abstention de vote",
  Answer_Acknowledged: "J'en ai pris connaissance",
  Answer_Discussion_Required: "Je demande une discussion",
  Answer_Group_Done: "Voté/Répondu",
  Answer_Group_Todo: "Voter/Répondre",
  Answer_No: "Non",
  Answer_Not_Answer: "Sans réponse",
  Answer_Response_Abstention: "Abstention de vote: {{totalAnswer}}",
  Answer_Response_Acknowledged: "Ont pris connaissance: {{totalAnswer}}",
  Answer_Response_Discussion_Required: "Ont demandé une discussion: {{totalAnswer}}",
  Answer_Response_No: "Ont refusé la demande: {{totalAnswer}}",
  Answer_Response_Not_Answer: "Sans réponse: {{totalAnswer}}",
  Answer_Response_Yes: "Ont accepté la demande: {{totalAnswer}}",
  Answer_Response_Yes_But: "Ont accepté la demande sous réserve: {{totalAnswer}}",
  Answer_Yes: "Oui",
  Answer_Yes_But: "Oui, sous réserve",
  App_Version: "Version",
  ApplicationName: "eDecide",
  AuditLog: "Journal d'audit",
  AuditLog_Action: "Action",
  AuditLog_Add: "Ajouté",
  AuditLog_After: "Après",
  AuditLog_Before: "Avant",
  AuditLog_Changes: "Modifications",
  AuditLog_Created: "Date",
  AuditLog_CreatedBy: "Utilisateur",
  AuditLog_Date: "A la date",
  AuditLog_Diff: "Différences",
  AuditLog_Id: "Id",
  AuditLog_Properties: "Champs",
  AuditLog_Property: "Champ",
  AuditLog_Remove: "Supprimé",
  AuditLog_State: "Action",
  AuditLog_Update: "Modifié",
  AuditLog_User: "par",
  AuditLogs: "Journaux d'audit",
  Auth_Loading: "Chargement de l'application …",
  Auth_LoginFailed: "La vérification a échoué.",
  Auth_Redirecting: "Chargement de vérification …",
  Auth_TryAgain: "Essaie à nouveau.",
  BackHome: "Retour à la page d'accueil",
  Board: "Organe",
  Board_Description: "Description",
  Board_Members: "Membres",
  Board_Members_Add: "Ajouter membre",
  Board_Name: "Nom",
  Board_Owners: "Propriétaires",
  Board_Owners_Add: "Ajouter un propriétaire",
  Board_RunThresholdDays: "Les activités archivées de plus de {{runThresholdDays}} jours ne sont pas affichées",
  Board_Status: "Statut",
  Board_Statuses: "Statut",
  Board_TopicKindCodes: "Types de thèmes disponibles",
  Board_UniqueId: "Clé",
  BoardConfiguration: "Configuration",
  BoardConfiguration_Emailtemplate: "Modèle d'email",
  BoardConfiguration_ReportTemplate: "Modèle de protocole",
  BoardRole: "Rôle d'organe",
  BoardRole_Member: "Membre",
  BoardRole_Owner: "Propriétaire",
  BoardRoles: "Rôles d'organe",
  Boards: "Organes",
  Boards_Empty: "Aucune organe n'existe.",
  Boards_NotFound: "Aucun organe n'a été trouvé avec ces critères",
  BoardStatus_Active: "actif",
  BoardStatus_Archived: "archivé",
  BoardStatus_Inactive: "inactif",
  By: "de",
  Cancel: "Annuler",
  ClaimIssuer: "Émetteur de la demande",
  Claims: "Demandes de l'utilisateur",
  ClaimType: "Type de demande",
  Confirm: "Je confirme",
  Confirm_Cancel: "Annuler",
  Confirm_Content: "Des modifications non enregistrées ont été détectées. Veux-tu vraiment annuler ?",
  Confirm_DeleteBoard_Text: "Souhaites-tu vraiement supprimer l'organe {{name}}?",
  Confirm_DeleteEmailTemplate_Text: "Suprimer le modèle email {{name}}",
  Confirm_DeleteReportTemplate_Text: "Supprimer le document {{name}}",
  Confirm_DeleteRun_Text: "Souhaites-tu vraiment supprimer l'activité {{title}}?",
  Confirm_Discard: "Rejeter les modifications",
  Confirm_RunStatus_Change: "Peux-tu confirmer le changement de statut e {oldStatus} à {newStatus}.",
  Confirm_RunStatus_Change_To_Archive_Title: "Archiver l'activité",
  Confirm_RunStatus_Change_To_Close: "Confirme la modification du statut '{oldStatus}' en 'terminé'. Si la course est associée à un organe SiVe (ID externe), les résultats seront transmis automatiquement après la fermeture.",
  Confirm_RunStatus_Change_To_Close_Title: "Terminer l'activité",
  Confirm_RunStatus_Change_To_Publish_Title: "Publier l'activité",
  Confirm_RunStatus_Change_To_Revise: "Merci de confirmer le changement de statut de «{oldStatus}» à «Révision». Le statut «Révision» permet d’adapter les propriétés de déroulement telles que la date de fin et le titre et d’ajouter de nouveaux participants.",
  Confirm_RunStatus_Change_To_Revise_Title: "Reviser l'activité",
  Confirm_Title: "Modifications non enregistrées",
  CopyToClipboard_Idle: "Copier dans le presse-papiers…",
  CopyToClipboard_Success: "Copié !",
  Created: "Crée",
  Date_Group_All: "Tout le monde",
  Date_Group_Oneyear: "âgé de 1 an maximum",
  Date_Group_Twomonths: "âgé de 2 mois maximum",
  Date_Group_Twoyears: "âgé de 2 ans ou moins",
  Date_Unknown: "Date inconnue",
  De: "Allemand",
  Details: "Détails",
  DismissableDialog_Close_Label: "Fermer",
  DismissableDialog_Close_Tooltip: "Ne plus afficher le message",
  Download: "Télécharger",
  Edit: "Modifier",
  Email_Invitation_Subject: "Invitation {{run.title}}",
  Email_Reminder_Publish: `{{boardName}} - eDecide activité {{runTitle}}
Ce message a été généré automatiquement.<br><br>
Chers participants à l'activité,<br><br>
La période de vote eDecide vient d'être lancé. Veuillez voter avant le {{expiryDate}} à {{expiryTime}}.<br><br>
En cliquant sur le lien ci-dessous, tu accédes directement au vote: <a href='{{voteLink}}'>{{runTitle}}</a><br><br>
Meilleures salutations<br><br>
{{boardOwnerName}}<br>
Administrateur de l'activité<br><br>

============================REPUBLISH============================


{{boardName}} - eDecide run {{runTitle}}
Ce message a été généré automatiquement.<br><br>
Chers participants à l'activité,<br><br>
La periode de vote eDecide vient d'être rouvert. Nous te prions de voter avant le {{expiryDate}} à {{expiryTime}}.<br><br>
En cliquant sur le lien ci-dessous, tu accédes directement au vote: <a href='{{voteLink}}'>{{runTitle}}</a><br><br>
Meilleures salutations<br><br>
{{boardOwnerName}}<br>
Administrateur de l'activité`,
  Email_Reminder_Subject: "Rappel {{title}}",
  EmptyTable: "Aucune donnée disponible dans le tableau",
  En: "Anglais",
  Entity: "Entité",
  Entity_Add_Failure: "{EntityName} n'a pas pu être créé.",
  Entity_Add_Success: "{EntityName} créé avec succès.",
  Entity_Delete_ConfirmContent: "Veux-tu vraiment supprimer {EntityName} ?",
  Entity_Delete_ConfirmTitle: "Confirmer la suppression",
  Entity_Delete_Failure: "{EntityName} n'a pas pu être supprimé.",
  Entity_Delete_Success: "{EntityName} a été supprimé avec succès.",
  Entity_Refresh_Failure: "{EntityName} n'a pas pu être rechargé.",
  Entity_Refresh_Success: "{EntityName} a été rechargé avec succès.",
  Entity_Save_Failure: "{EntityName} n'a pas pu être enregistré.",
  Entity_Save_Success: "{EntityName} sauvegardé avec succès.",
  Entity_Update_Failure: "{EntityName} n'a pas pu être mis à jour.",
  Entity_Update_Success: "{EntityName} mis à jour avec succès.",
  EntityCount: "# Entrées",
  EntityTitle_Unknown: "Inconnu",
  Error_FailedToAddUser: "L'utilisateur '{0}' n'a pas pu être ajouté.",
  ErrorCodes_BadRequest: "Quelque chose a échoué dans la requête. Il s'agit d'une erreur du client (par exemple: syntaxe de requête incorrecte, cadrage non valide du message de requête ou routage de requête trompeur).",
  ErrorCodes_InternalServerError: "Une erreur s'est produite lors du traitement de ta demande.",
  ErrorCodes_NoResponse: "Le service backend n'est pas disponible.",
  ErrorCodes_NotFound: "La ressource n'a pas été trouvée.",
  ErrorCodes_Unauthorized: "Tu n'as pas accès à la ressource.",
  Exception: "Exception",
  Exists: "Existe",
  File_Picker_Not_Valid_File: "Format de fichier incorrect!",
  FileAction_Delete: "Sera supprimé",
  FileAction_Existing: "Existant",
  FileAction_New: "Sera téléchargé",
  FileAction_Overwrite: "Sera écrasé",
  FileUpload_ProtectedFile_Message: "Il a été détecté que le fichier transféré '{0}' était crypté.",
  FileUpload_ProtectedFile_Title: "Fichier protégé ne sera pas téléchargé",
  Filter_Active_Icon_Tooltip: "Modifier le filtre",
  Filter_Clear_Icon_Tooltip: "Supprimer le filtre",
  Filter_Combobox_Filter_Customize: "Filtre",
  Filter_Icon_Tooltip: "Appliquer le filtre",
  Filter_Search_Placeholder: "Rechercher…",
  Footer_HelpAndSupport: "Aide & Support",
  Footer_HelpTitle: "SBB eDecide Aide",
  Footer_Imprint: "Mentions légales",
  Footer_Title: "Mentions légales et aide",
  Fr: "Français",
  Group: "Groupe",
  Group_Add: "Ajouter un groupe",
  Group_AddError: "Le groupe n'a pas pu être ajouté",
  Group_AddSuccess: "Le groupe a été ajouté avec succès",
  Group_ConfirmDelete: "Tu veux vraiment supprimer le groupe?",
  Group_DeleteError: "Le groupe n'a pas pu être supprimé",
  Group_EntraIdName: "Nom dans Entra ID",
  Group_EntraIdName_Description: "Si tu associes ici un groupe Entra ID (Omada), les membres sont importés périodiquement. Si aucune liaison n’est définie, les membres peuvent être supprimés et ajoutés à droite.",
  Group_Id: "Nom",
  Group_MemberCount: "No. membres",
  Group_Members: "Membres",
  Group_Name: "Nome",
  Group_Search: "Recherche de groupe …",
  Group_SearchStringHint: "Il s'agit du nom du groupe AD pris en charge.",
  Group_Titles: "Groupes AD",
  GroupMember_ExistsInGroup: "Existe en groupe",
  Groups: "Groups",
  Header_English: "English",
  Header_French: "Français",
  Header_German: "Deutsch",
  Header_Help: "Aide",
  Header_Italian: "Italiano",
  Header_Version: "Version",
  Help: "Aide",
  HelpMenu_CosProductPage: "Produit COS eGPL 2",
  HelpMenu_Manuals: "Manuels",
  HelpMenu_Support: "Support",
  HelpMenu_VivaEngage: "Groupe Viva Engage eGPL 2",
  Helppage: "Page d'aide",
  Home: "Accueil",
  Id: "Id",
  ImportedFromPhonebook: "Champs importées de l'annuaire téléphonique",
  It: "Italien",
  KeywordSearch: "Recherche par mots-clés",
  LastModified: "Dernière modification",
  LastModifiedBy: "Dernière modification par",
  LastSync: "Dernière synchronisation",
  Loading: "Chargement …",
  Logout: "Déconnexion",
  Message_Confirm_No: "NON",
  Message_Confirm_Question: "Peux-tu confirmer l'action?",
  Message_Confirm_Yes: "OUI",
  Modified: "Modifiée",
  Navigation_Administration: "Administration",
  Navigation_All_Boards: "Tous les organes",
  Navigation_Completed_Votes: "Votes terminés",
  Navigation_My_Boards: "Mes organes",
  Navigation_Open_Votes: "Votes en cours",
  No: "Non",
  Ok: "OK",
  OpenLinkNewWindow: "Ouvrir le lien (dans une nouvelle fenêtre)",
  OriginalPath: "Chemin de requête",
  Page_Admin_Title: "Administration",
  Page_Board_Title: "Organe «{0}»",
  Page_BoardEdit_Title: "Gérer l'organe «{{name}}»",
  Page_Cache_Title: "Cache",
  Page_Claims_Title: "User claims",
  Page_Dashboard_Title: "Dashboard",
  Page_Error_SubTitle: "Une erreur s'est produite lors du traitement de votre demande.",
  Page_Error_Title: "Erreur",
  Page_Group_Title: "Groupe «{0}»",
  Page_Groups_Title: "Groups",
  Page_JobStatus_Title: "Statut du travail",
  Page_Mails_Title: "Test d'Inxmail",
  Page_Memory_Title: "Memoire",
  Page_Resources_Title: "Traductions",
  Page_Run_Title: "Activité «{{title}}»",
  Page_Translations_Title: "Traductions",
  Page_User_Title: "Utilisateur «{0}»",
  Page_UserEdit_Title: "Modifier l'utilisateur «{0}»",
  Page_Users_Title: "Utilisateurs",
  Paging_First: "Premier",
  Paging_Last: "Dernier",
  Paging_Next: "Suivant",
  Paging_Previous: "Précédente",
  Paging_Stats: "Affichage de _START_ à _END_ sur _TOTAL_ éléments",
  Paging_StatsFiltered: "(filtré à partir de _MAX_ éléments au total)",
  Participant: "Participant/e",
  Participant_Answered_Stats: "repondu {{answered}}/{{totalTopic}}",
  Participant_Answers: "Résponses",
  Participant_Initials: "Initiales",
  Participant_Name: "Name",
  Participant_Role: "Rôle",
  Participant_Status: "Statut",
  Participants: "Participant/es",
  Permissions: "Droits d'accès",
  Personalisation: "Personnalisation",
  Preview_Report: "Aperçu du protocole",
  Properties: "Propriétés",
  PublishRun_MailSubject: "Sujet de l'email",
  PublishRun_MailSubject_Reminder_To_All: "Chers participants à l'activité,<br><br>",
  PublishRun_MailText: "Texte de l'email",
  PublishRun_SendTo: "Destinataires",
  PublishRun_SendType: "Méthode d'expédition",
  RequestId: "ID de requête",
  Reset: "Réinitialiser",
  RichText_Link_Dialog_Title: "Modifier lien",
  RichText_Link_Invalid_URL: "Prière d’entrer une URL valide (https://, http://, mailto:)",
  RichText_Link_Remove: "Supprimer lien",
  RichText_Link_Text_Label: "Texte affiché",
  RichText_Link_URL_Label: "Objectif",
  RichText_Paste_Cancel_Tooltip: "Annuler (annuler le collage)",
  RichText_Paste_KeepFormatting_Tooltip: "Conserver la mise en forme",
  RichText_Paste_Options_Trigger_Tooltip: "Options de collage (Ctrl)",
  RichText_Paste_PlainText_Tooltip: "Insérer en texte brut",
  Richtext_Placeholder: "Saisir texte …",
  RichText_Tooltip_Background: "Couleur de fond",
  RichText_Tooltip_Blockquote: "Appliquer en format de justification",
  RichText_Tooltip_Bold: "Gras (CTRL+B)",
  RichText_Tooltip_Clean: "Supprimer le format",
  RichText_Tooltip_Color: "Couleur du texte",
  RichText_Tooltip_Heading: "Titre",
  RichText_Tooltip_Indent_Minus1: "Reduire l'intendation (Shift+Tab)",
  RichText_Tooltip_Indent_Plus1: "Augmenter l'intendation (Tab)",
  RichText_Tooltip_Italic: "Italique (Ctrl+I)",
  RichText_Tooltip_Link: "Ajouter un lien",
  RichText_Tooltip_List_Bullet: "Ajouter une liste",
  RichText_Tooltip_List_Ordered: "Ajouter une liste numérotée",
  RichText_Tooltip_Script_Sub: "Indice",
  RichText_Tooltip_Script_Super: "Exposant",
  RichText_Tooltip_Size: "Grandeur du texte",
  RichText_Tooltip_Source: "Afficher le code source HTML",
  RichText_Tooltip_Strike: "Barré",
  RichText_Tooltip_Underline: "Souligner (Ctrl+U)",
  Run: "Activité",
  Run_ArchivedBy: "Archivé par",
  Run_ArchiveType: "Type d'archivage",
  Run_Boardname: "Organe",
  Run_ClosedBy: "Fermé par",
  Run_ClosedDate: "Heure de clôture (effective)",
  Run_CloseType: "Type de clôture",
  Run_Comment: "Commentaire",
  Run_Expirydate: "Date de fin",
  Run_Expirytime: "Heure de fin",
  Run_Externalid: "Id externe (SiVe)",
  Run_Key: "Id",
  Run_NotFound: "Aucune activité n'existe",
  Run_SiVeTransferResult: "Transfert SiVe",
  Run_Status: "Statut",
  Run_Title: "Titre",
  RunParticipant: "Participant/e de l'activité",
  RunParticipant_NotFound: "Utilisateur pas disponible",
  RunParticipants: "Participant/es de l'activité",
  RunParticipants_Add: "Ajouter des participants",
  RunParticipants_Invalid: "Liste des participants incorrecte",
  RunParticipants_SearchMember: "Chercher un membre de l'organe:",
  RunRole_AdditionalParticipant: "Participant supplémentaire",
  Runs: "Activités",
  Runs_Empty: "Aucune activité trouvé.",
  RunStatus_All: "Tous",
  RunStatus_Archived: "Archivé",
  RunStatus_ArchivedAndWillBeDeleted: "Archivé, sera supprimé le {0}",
  RunStatus_ClosedFromPublished: "Terminé",
  RunStatus_ClosedFromRepublished: "Terminé",
  RunStatus_Preparing: "En préparation",
  RunStatus_Published: "Publié",
  RunStatus_Republished: "Publié à nouveau",
  RunStatus_Unknown: "Inconnu",
  RunTopic: "Thème",
  RunTopic_Content: "Contenu",
  RunTopic_Documents: "Liste des documents",
  RunTopic_InfoText: "Contenu (Infotext)",
  RunTopic_Number: "Numéro de thème",
  RunTopic_Question: "Contenu (Question)",
  RunTopic_Result: "Résultat",
  RunTopic_Title: "Titre du thème",
  RunTopic_TopicKindCode: "Type de thème",
  RunTopics: "Thèmes",
  RunTopics_Empty: "Aucun thème trouvé.",
  RunTopicType_Agenda_Content: "Demande",
  RunTopicType_Decision_Content: "Demande",
  RunTopicType_Info_Content: "Texte",
  RunTopicType_Protocol_Content: "Demande pour le protocoll",
  RunTopicVote: "Résultat du vote",
  RunTopicVotes: "Résultats du vote",
  Save: "Enregistrer",
  Select_Placeholder: "Sélectionner …",
  SelectAll: "Sélectionner tout",
  Send_Mail_Download: "télécharger l'email",
  Send_Mail_Publish: "Publier",
  Send_Mail_Send: "envoyer",
  Send_Mail_Send_Reminder_To_All: "Le cycle de vote eDecide vient d'être lancé. Veuillez voter avant le {{expiryDate}} à {{expiryTime}}.<br><br>",
  Send_Mail_Text: "Texte de l'email",
  SendTo_All: "Tous (participants et membres administrateur)",
  SendTo_BoardOwners: "Membres administrateur",
  SendTo_Participants: "Participants",
  SendTo_ParticipantsWhoNotVoted: "Participants qui n'ont pas encore voté",
  SendType_DoNotSend: "Ne pas envoyer les Emails",
  SendType_Download: "Télécharger l'email et l'envoyer manuellement via Outlook",
  SendType_FromEdecide: "Envoyer un email directement depuis eDecide",
  Sive_MeetingDoesNotExist: "L'activité, que tu veux fermer, n'existe plus en SiVe!",
  Sive_MeetingMightBeDeleted: "La séance dans SiVe n'existe peut-être plus.",
  Sive_Result_IsSentOnClose: "Les résultats seront envoyés à SiVe à la clôture de l'activité.",
  Sive_ResultsWereSent: "Les résultats ont été envoyés à SiVe lors de la clôture de l'activité.",
  Sive_RunCreatedFromSive: "Cette activite a été créée à partir d'une séance dans SiVe.",
  Statistics: "Statistiques",
  Status_All: "Tout",
  Status_Archived: "Archivé",
  Status_Button_Archive: "Archiver",
  Status_Button_Close: "Fermer l'activité",
  Status_Button_Publish: "Publier",
  Status_Button_Republish: "Publier à nouveau",
  Status_Button_Revise: "Réviser",
  Status_Closed: "Terminé",
  Status_Preparing: "En préparation",
  Status_Published: "Publié",
  Status_Republished: "Publié à nouveau",
  Status_Revise: "Révision",
  StatusCode_401_SubTitle: "Vous n'avez pas accès à la ressource.",
  StatusCode_401_Title: "Accès refusé",
  StatusCode_403_SubTitle: "Vous n'avez pas la permission d'accéder à la ressource.",
  StatusCode_403_Title: "Interdit",
  StatusCode_404_SubTitle: "La ressource n'a pas été trouvée.",
  StatusCode_404_Title: "Pas trouvé",
  Table_NoRows: "Aucun record trouvé.",
  Tag_Old: "Vieux",
  Today: "Aujourd'hui",
  Topic_Agenda: "Agenda",
  Topic_Decision: "Vote",
  Topic_Info: "Info",
  Topic_Protocol: "Entrée de protocole",
  TopicCode_Agenda_Content: "Texte",
  TopicCode_Protocol_Content: "Texte du protocole",
  Total: "Totale",
  User: "Utilisateur",
  User_AnonymizedDisplayName: "Utilisateur supprimé",
  User_Boards: "Organes",
  User_DisplayName: "Nom",
  User_Email: "Email",
  User_FirstName: "Prénom",
  User_Initials: "Initiales",
  User_Initials_HelpText: `Si tu laisses le champ vide, le standard sera appliqué.<br/>
Première lettre du prénom, première lettre du nom de famille.`,
  User_Initials_Preview: "Preview",
  User_Language: "Langue",
  User_LastName: "Nom de famille",
  User_LastSync: "Dernière synchronisation",
  User_OrganisationUnit: "Unité organisationnelle",
  User_PersonalSiteUrl: "URL du MySite SharePoint (OneDrive)",
  User_PersonnelNumber: "N° de personnel",
  User_Phone: "Téléphone",
  User_Status: "Statut",
  User_Update_Error: "L'utilisateur n&apos;a pas pu être enregistré : {0}",
  User_Update_Success: "L'utilisateur a été enregistré",
  User_Upn: "Nom principal",
  User_UserRoles: "Rôles",
  UserMenu_MyDetails: "Mon profil",
  UserMenu_SignOut: "Se déconnecter",
  UserPicker: "Rechercher des utilisateurs",
  UserPicker_NoDataTemplate: "Pas trouvé de participants",
  UserPicker_Placeholder: "Saisir identifiant …",
  UserRole_Administrator: "Administrateur",
  UserRole_Application: "Application",
  UserRole_Unknown: "Inconnu",
  UserRole_User: "Utilisateur",
  Users: "Utilisateurs",
  UserStatus_Deleted: "Supprimé",
  UserStatus_Enabled: "Actif",
  UserStatus_Unknown: "Inconnu",
  Validation_At_Least_One_Owner: "Au moins un détenteur de l'organe.",
  Validation_Board_AtLeastOneBoardOwner: "Au moins un détenteur doit être défini.",
  Validation_Board_AtLeastOneUser: "Au moins un participant à l'organe doit être défini.",
  Validation_Board_DuplicateTopicKindCode: "Des duplicata sont présent dans les types de thèmes.",
  Validation_Board_InvalidTopicKindCode: "Il existe des types de thèmes non valables.",
  Validation_Board_NotUnique: "L'organe doit être unique. Contrôle le champ 'Nom'.",
  Validation_Board_UniqueKeySizeNot12: "La 'UniqueKey' doit comporter exactement 12 caractères.",
  Validation_Description_NotEmpty: "Le description ne doit pas être vide.",
  Validation_ExpiryDate_Invalid: "Terme pas valide!",
  Validation_InvalidPosition: "Déplacement impossible. Position non valable.",
  Validation_Name_NotEmpty: "Le nom ne doit pas être vide.",
  Validation_Required: "'{PropertyName}' est obligatoire.",
  Validation_Run_CodesNotUnique: "Les numéros de thèmes doivent être unique, duplicata:  [{0}].",
  Validation_Run_NotUnique: "L'activité doit être unique dans l'organe. Contrôle le champ 'Titre'.",
  Validation_RunTopic_NotUnique: "Un thème doit être unique dans l'activité. Contrôle le champ 'Numéro de thème'.",
  Validation_TextLongerThanRecommended: "Recommandé : pas plus de {{length}} caractères.",
  Validation_Title_NotEmpty: "Le titre ne doit pas être vide.",
  ValidationFailures: "Erreurs de validation",
  VoteChart_Answered: "Thèmes avec réponse",
  VoteChart_NotAnswered: "Thèmes sans réponse",
  Votes_NotFound: "Aucun vote n'a été trouvé avec ces critères",
  Voting_MyAnswer: "Ma réponse",
  Voting_MyComment: "Mon commentaire",
  Voting_RunNotPublished: "L'activité n'a pas été publié.",
  Yes: "Oui",
};
